export function hasActiveFilters(routeQuery) {
  const filters = JSON.parse(routeQuery?.filters || "{}");
  return Object.keys(filters).length > 0;
}
